import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, Lock, LogIn } from 'lucide-react';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';
import API_URL from '../api';

function Login() {
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const bg = darkMode ? '#0f0f1a' : '#f0f2f5';
  const card = darkMode ? '#1a1a2e' : '#fff';
  const border = darkMode ? 'rgba(255,255,255,0.08)' : '#e0e0e0';
  const text = darkMode ? '#e0e0e0' : '#333';
  const subtext = darkMode ? '#888' : '#666';
  const inputBg = darkMode ? '#0f0f1a' : '#f8f8f8';

  const handleLogin = async () => {
    setLoading(true); setError('');
    try {
      const res = await axios.post(`${API_URL}/api/auth/login`, form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed!');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <style>{`@keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }`}</style>
      <div style={{ width: '100%', maxWidth: '420px', animation: 'fadeInUp 0.5s ease' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ background: 'linear-gradient(135deg, #e94560, #c62a47)', borderRadius: '16px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', fontSize: '28px', boxShadow: '0 8px 25px rgba(233,69,96,0.3)' }}>🎓</div>
          <h1 style={{ color: text, fontSize: '26px', fontWeight: '700', marginBottom: '6px' }}>Welcome Back!</h1>
          <p style={{ color: subtext, fontSize: '14px' }}>Login to access your tickets</p>
        </div>
        <div style={{ background: card, borderRadius: '20px', padding: '35px', border: `1px solid ${border}`, boxShadow: darkMode ? '0 20px 60px rgba(0,0,0,0.4)' : '0 20px 60px rgba(0,0,0,0.08)' }}>
          {error && <div style={{ background: darkMode ? 'rgba(233,69,96,0.15)' : '#ffebee', border: '1px solid rgba(233,69,96,0.3)', borderRadius: '10px', padding: '12px 15px', marginBottom: '20px', color: '#e94560', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>❌ {error}</div>}
          <div style={{ marginBottom: '14px' }}>
            <label style={{ color: subtext, fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Email Address</label>
            <div style={{ position: 'relative' }}>
              <Mail size={16} color="#888" style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)' }} />
              <input placeholder="your@email.com" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={{ background: inputBg, border: `1.5px solid ${border}`, color: text, padding: '12px 12px 12px 42px', borderRadius: '10px', fontSize: '14px', width: '100%', outline: 'none', fontFamily: 'inherit' }} />
            </div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: subtext, fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Password</label>
            <div style={{ position: 'relative' }}>
              <Lock size={16} color="#888" style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)' }} />
              <input placeholder="••••••••" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} onKeyDown={e => e.key === 'Enter' && handleLogin()} style={{ background: inputBg, border: `1.5px solid ${border}`, color: text, padding: '12px 12px 12px 42px', borderRadius: '10px', fontSize: '14px', width: '100%', outline: 'none', fontFamily: 'inherit' }} />
            </div>
          </div>
          <button onClick={handleLogin} disabled={loading} style={{ background: 'linear-gradient(135deg, #e94560, #c62a47)', color: '#fff', width: '100%', padding: '14px', fontSize: '15px', borderRadius: '12px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 15px rgba(233,69,96,0.3)' }}>
            {loading ? '⏳ Logging in...' : <><LogIn size={17} /> Login</>}
          </button>
          <div style={{ textAlign: 'center' }}>
            <Link to="/forgot-password" style={{ color: '#e94560', fontWeight: '600', textDecoration: 'none', fontSize: '14px' }}>Forgot Password?</Link>
          </div>
        </div>
        <p style={{ textAlign: 'center', color: subtext, fontSize: '14px', marginTop: '20px' }}>
          Don't have an account?{' '}
          <Link to="/signup" style={{ color: '#e94560', fontWeight: '600', textDecoration: 'none' }}>Sign Up</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;